// extracted by mini-css-extract-plugin
module.exports = {"container":"PanelCategory_container__2ywKt","title":"PanelCategory_title__2RLOE"};